import type { CalendarAppointment } from '@odo/shared-ui';

/**
 * Upcoming (today or later) appointments matching the modal header's search box,
 * soonest first. Shared by the header's count and the PDF so the two cannot drift;
 * the calendar's own tab and selected-day filters are internal to it and ignored.
 */
export function selectUpcoming(
    appointments: readonly CalendarAppointment[],
    search: string,
    todayIso: string
): CalendarAppointment[] {
    const trimmedSearch = search.trim().toLowerCase();
    return appointments
        .filter(
            (appointment) =>
                appointment.date >= todayIso &&
                (!trimmedSearch || appointment.patientName.toLowerCase().includes(trimmedSearch))
        )
        .sort((a, b) => a.date.localeCompare(b.date) || (a.time ?? '').localeCompare(b.time ?? ''));
}
